module.exports = __webpack_public_path__ + "static/media/8.ceff5306.jpg";